import React, { useState } from 'react';
import { Navbar, Nav, Container, Button, Offcanvas } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

const AdminNavbar = ({ onLogout, user }) => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const location = useLocation();

  const isActive = (path) => location.pathname.startsWith(path);

  const toggleMenu = (label) => {
    setOpenMenu(openMenu === label ? null : label);
  };

  const menuItems = [
    {
      path: '/admin/dashboard',
      label: 'Dashboard',
      icon: 'fas fa-tachometer-alt',
    },
    {
      path: '/admin/SiteHeaderManager',
      label: 'Site Header',
      icon: 'fas fa-heading',
    },
     {
      label: 'Fornt Page',
      icon: 'fas fa-home',
      children: [
        { path: '/admin/QuickStatsManager', label: 'Quick Stats' },
        { path: '/admin/AdminHomeSlider', label: 'Home Page Slider' },
        { path: '/admin/QuickLinksManager', label: 'Top Quick Links' },
        { path: '/admin/FeaturesManager', label: 'Features Manager' },
        { path: '/admin/AboutContentManager', label: 'Content Manager' },
        { path: '/admin/AnnouncementsManager', label: 'Announcements' },
        { path: '/admin/TeamMembersManager', label: 'Team Members' },
        { path: '/admin/TestimonialsManager', label: 'Testimonials' },
        { path: '/admin/CallToActionManager', label: 'Call To Action' },
        
       
      ],
    },
    {
      label: 'Academic',
      icon: 'fas fa-calendar-alt',
      children: [
        { path: '/admin/academic-years', label: 'Academic Years' },
        { path: '/admin/CoursesManager', label: 'Courses' },
        { path: '/admin/AdmissionProcedureManager', label: 'Admission Procedure' },
        { path: '/admin/ProspectusManagement', label: 'Prospectus' },
        { path: '/admin/departments', label: 'Departments' },
        { path: '/admin/CalendarEventsManager', label: 'Calendar of Events' },
      ],
    },
    {
      label: 'Content Management',
      icon: 'fas fa-folder',
      children: [
        { path: '/admin/about_college', label: 'About Us' },
        { path: '/admin/ServicesManager', label: 'Services' },
        { path: '/admin/OwnerProfilesManager', label: 'Owner Profiles' },
        { path: '/admin/ProjectsManager', label: 'Projects Manager' },
        { path: '/admin/GalleryManager', label: 'Photo / Video Gallery' },
        { path: '/admin/ContactManager', label: 'Contact' },
        { path: '/admin/LeadershipMessagesManager', label: 'Leadership Messages' },
        { path: '/admin/FacilitiesManager', label: 'Facilities' },
        { path: '/admin/StaffManager', label: 'Staff Manager' },
        { path: '/admin/AcademicEventsManager', label: 'Academic Events' },
        { path: '/admin/OrganizationsManager', label: 'Organizations' },
      ],
    },
    {
      path: '/admin/SchoolInfoManager',
      label: 'Public Disclosure',
      icon: 'fas fa-user-tie',
    },
    {
      label: 'Settings',
      icon: 'fas fa-cogs',
      children: [
        { path: '/admin/MenuManager', label: 'Menu Manager' },
        { path: '/admin/ChangePassword', label: 'Change Password' },
      ],
    },
  ];

  return (
    <>
      {/* ================= TOP NAVBAR ================= */}
      <Navbar bg="dark" variant="dark" expand="lg" className="sticky-top shadow-sm">
        <Container fluid>
          <Button
            variant="outline-light"
            className="me-2"
            onClick={() => setShowSidebar(true)}
          >
            <i className="fas fa-bars"></i>
          </Button>

          <Navbar.Brand as={Link} to="/admin/dashboard" className="fw-bold">
            <i className="fas fa-university me-2"></i>
            Web Admin Panel 
          </Navbar.Brand>

          <Nav className="ms-auto align-items-center">
            {user && (
              <Nav.Item className="text-light me-3 d-none d-md-block">
                <i className="fas fa-user-circle me-2"></i>
                {user.username}
              </Nav.Item>
            )}
            
            <Button variant="outline-light" size="sm" onClick={onLogout}>
              <i className="fas fa-sign-out-alt me-2"></i>
              Logout
            </Button>
          </Nav>
        </Container>
      </Navbar>

      {/* ================= SIDEBAR ================= */}
      <Offcanvas
        show={showSidebar}
        onHide={() => setShowSidebar(false)}
        placement="start"
        style={{ width: '260px' }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <i className="fas fa-university me-2 text-primary"></i>
            Admin Menu
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body className="p-0">
          <div className="sidebar-menu">
            {menuItems.map((item) => (
              <div key={item.label}>
                {/* MAIN MENU ITEM */}
                {item.path ? (
                  <Link
                    to={item.path}
                    className={`sidebar-item d-flex align-items-center p-3 border-bottom text-decoration-none ${
                      isActive(item.path) ? 'active' : ''
                    }`}
                    onClick={() => setShowSidebar(false)}
                  >
                    <i className={`${item.icon} me-3`}></i>
                    {item.label}
                  </Link>
                ) : (
                  <div
                    className="sidebar-item d-flex align-items-center p-3 border-bottom"
                    onClick={() => toggleMenu(item.label)}
                    style={{ cursor: 'pointer' }}
                  >
                    <i className={`${item.icon} me-3`}></i>
                    <span className="flex-grow-1">{item.label}</span>
                    <i
                      className={`fas fa-chevron-${
                        openMenu === item.label ? 'up' : 'down'
                      }`}
                    ></i>
                  </div>
                )}

                {/* SUB MENU */}
                {item.children && openMenu === item.label && (
                  <div className="submenu">
                    {item.children.map((sub) => (
                      <Link
                        key={sub.path}
                        to={sub.path}
                        className={`submenu-item d-block ps-5 py-2 text-decoration-none ${
                          isActive(sub.path) ? 'active' : ''
                        }`}
                        onClick={() => setShowSidebar(false)}
                      >
                        {sub.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default AdminNavbar;
